<mat-tab-group
  onsip-mat-tab-table
  class="onsip-tab-group-full-height"
  mat-align-tabs="start"
  mat-stretch-tabs="false"
  (selectedIndexChange)="onSelectedIndexChange($event)"
>
  <mat-tab label="Phone Info">
    <ng-template matTabContent>
      @if ((phoneInfoView | async) === 'view') {
      <onsip-phone-info
        [phoneInfo]="phoneInfo"
        [phoneFeatures]="phoneFeatures"
        [noFeatures]="noFeatures"
        (editPanel)="toggleInfoPanel('edit')"
      >
      </onsip-phone-info>
      } @else {
      <onsip-phone-info-edit
        [phoneInfo]="phoneInfo"
        [phoneFeatures]="phoneFeatures"
        [noFeatures]="noFeatures"
        (viewPanel)="toggleInfoPanel('view')"
      >
      </onsip-phone-info-edit>
      }
    </ng-template>
  </mat-tab>
  <mat-tab label="Phone Lines">
    <ng-template matTabContent>
      @if ((phoneLinesView | async) === 'view') {
      <onsip-phone-lines
        [phoneInfo]="phoneInfo"
        [lines]="lines"
        [expansionModuleName]="expansionModuleName"
        (editPanel)="toggleLinesPanel('edit')"
      >
      </onsip-phone-lines>
      } @else {
      <onsip-phone-lines-edit
        [phoneInfo]="phoneInfo"
        [lines]="lines"
        [isUsingExpansionModule]="expansionModuleName !== ''"
        (viewPanel)="toggleLinesPanel('view')"
      >
      </onsip-phone-lines-edit>
      }
    </ng-template>
  </mat-tab>
</mat-tab-group>
